import { AssignmentsHistoryEntry } from "./AssignmentsHistoryEntry";

export class AssignmentsHistory {
    id: string;
    history: AssignmentsHistoryEntry[];
    constructor(id: string, history: AssignmentsHistoryEntry[]) {
        this.id = id;
        this.history = history;
    }

}

